import { DialogContent, IconButton, List, ListItem, ListItemText, Tooltip } from "@mui/material";
import { Company } from "models/Company";
import Clear from "@mui/icons-material/Clear";
import { useGetUsersQuery, useRemoveUserFromCompanyMutation } from "app/api/companies";
import EmptyMessage from "components/EmptyMessage";
import AddUserForm from "../components/AddUserForm";
import { useAuthContext } from "features/auth/AuthContext";
import { UserRole } from "features/auth/types/user";

type UsersSectionProps = { company: Company };

const UsersSection: React.FC<UsersSectionProps> = (props) => {
  const { company } = props;

  const { hasRole } = useAuthContext();
  const canEditCompanies = hasRole([UserRole.ADMIN, UserRole.USER_ADMIN]);

  const { data: users } = useGetUsersQuery({ companyId: company.id });

  const [removeUserFromCompany, { isLoading: isRemovingUser }] = useRemoveUserFromCompanyMutation();

  return (
    <>
      <DialogContent sx={{ p: 1 }}>
        <List disablePadding>
          {!users?.length && (
            <ListItem divider>
              <ListItemText primary={<EmptyMessage>Inga användare hittades</EmptyMessage>} />
            </ListItem>
          )}
          {users?.map((user) => (
            <ListItem
              key={user.id}
              divider
              secondaryAction={
                <Tooltip arrow title="Ta bort användaren från företaget">
                  <IconButton
                    loading={isRemovingUser}
                    hidden={!canEditCompanies}
                    onClick={() =>
                      removeUserFromCompany({ companyId: company.id, userId: user.id })
                    }
                  >
                    <Clear />
                  </IconButton>
                </Tooltip>
              }
            >
              <ListItemText
                primary={user.userName}
                secondary={user.email}
                slotProps={{ primary: { fontWeight: "bold" } }}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>

      {canEditCompanies && <AddUserForm company={company} />}
    </>
  );
};

export default UsersSection;
